const brickCreationScript = `
  const unmountPaymentBrick = async () => {
    if (window.paymentBrickController) {
      try {
        await window.paymentBrickController.unmount();
        window.paymentBrickController = null;
      } catch (error) {
        console.error('Error during unmount:', error);
      }
    }
  };

  unmountPaymentBrick();
  const mp = new MercadoPago(window.paymentBricksProps.publicKey, {
    locale: window.paymentBricksProps.language,
    trackingDisabled: true
  });

  const bricksBuilder = mp.bricks({ theme: window.paymentBricksProps.theme });
  const renderPaymentBrick = async (bricksBuilder) => {

    const settings = {
      initialization: {
        /*
         "amount" é o valor total a ser pago por todos os meios de pagamento
       com exceção da Conta Mercado Pago e Parcelamento sem cartão de crédito, que tem seu valor de processamento determinado no backend através do "preferenceId"
        */
        amount: window.paymentBricksProps.amount,
        payer: window.paymentBricksProps.payer,
        preferenceId: window.paymentBricksProps.preferenceId,
      },
      customization: {
        paymentMethods: window.paymentBricksProps.paymentMethod,
        visual: {
          hidePaymentButton: window.paymentBricksProps.hidePaymentButton,
          hideFormTitle: window.paymentBricksProps.hideFormTitle,
          texts: window.paymentBricksProps.texts,
          style: {
            customVariables: window.paymentBricksProps.customVariables,
          },
        },
      },
      callbacks: {
        onReady: () => {
          /*
           Callback chamado quando o Brick estiver pronto.
           Aqui você pode ocultar loadings do seu site, por exemplo.
          */
          // dispatchEvent(new Event('paymentBrickReady'));
        },
        onSubmit: ({ selectedPaymentMethod, formData }) => {
          // callback chamado ao clicar no botão de submissão dos dados
          return new Promise((resolve, reject) => {
            fetch("/process_payment", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
              .then((response) => response.json())
              .then((response) => {
                // receber o resultado do pagamento
                resolve();
              })
              .catch((error) => {
                // lidar com a resposta de erro ao tentar criar o pagamento
                reject();
              });
          });
        },
        onError: (error) => {
          // callback chamado para todos os casos de erro do Brick
          console.error(error);
        },
      },
    };
    window.paymentBrickController = await bricksBuilder.create(
      "payment",
      "paymentBrick_container",
      settings
    );
   };
   renderPaymentBrick(bricksBuilder);
  `;

const paymentMethods = ['mercadoPago', 'creditCard', 'debitCard', 'ticket', 'bankTransfer', 'atm'];

module.exports = { brickCreationScript, paymentMethods };
